// extracted by mini-css-extract-plugin
export default {"text":"styles_text__l6RJV","center":"styles_center__9aKmY"};